import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaxationTypeEnum } from '@zaoblako/shared/modules/catalog/enums/taxation-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable descriptions for {@link ApprovalSchemeTypeEnum} enumeration values */
export const TaxationTypeEnumDescriptionI18n: EnumI18nInterface<TaxationTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [TaxationTypeEnum.GENERAL]: 'Общая система налогообложения',
    [TaxationTypeEnum.SINGLE_IMPUTED_INCOME]: 'Единый налог на вменённый доход',
    [TaxationTypeEnum.SINGLE_AGRICULTURAL]: 'Единый сельскохозяйственный налог',
    [TaxationTypeEnum.PATENT]: 'Патентная система налогообложения',
    [TaxationTypeEnum.SIMPLIFIED_15]: 'Упрощённая система налогообложения (разница между доходами и расходами)',
    [TaxationTypeEnum.SIMPLIFIED_6]: 'Упрощённая система налогообложения (вся выручка)',
  },
  [I18nLocalesEnum.EN_US]: {
    [TaxationTypeEnum.GENERAL]: 'General tax system',
    [TaxationTypeEnum.SINGLE_IMPUTED_INCOME]: 'A single tax on imputed income',
    [TaxationTypeEnum.SINGLE_AGRICULTURAL]: 'Single agricultural tax',
    [TaxationTypeEnum.PATENT]: 'Patent taxation system',
    [TaxationTypeEnum.SIMPLIFIED_15]: 'Simplified tax system (difference between income and expenses)',
    [TaxationTypeEnum.SIMPLIFIED_6]: 'Simplified taxation system (all revenue)',
  },
};
